import { IEnv } from './env.types';

export const Env:IEnv = {
  ...window.config,
};
